module.exports = __webpack_public_path__ + "img/ug.5c0aa5dd.svg";